import Graphic from "@arcgis/core/Graphic";
import { useTranslation } from "react-i18next";

function useSetPopupContent() {
    const { i18n } = useTranslation();

    const setPopupContent = (feature: { graphic: Graphic }): string => {
        const areaSize = feature?.graphic?.attributes?.ala_ha;
        const areaSizeRounded = areaSize !== undefined ? areaSize.toFixed(2) : 0;
        
        if (i18n.language === "en") {
            return `
                <p>
                    <span><b>Area name</b>: {nimi}.</span><br/>
                    <span><b>Municipality</b>: {kunta}.</span><br/>
                    <span><b>County:</b> {maakunta}.</span><br/>
                    <span><b>Area (ha):</b> ${areaSizeRounded}.</span><br/>
                    <span><b>Greenpeace link:</b> <a href="{gp_link}">click here</a>.</span>
                </p>                
            `;
        }
        else {
            return `
                <p>
                    <span><b>Alueen nimi</b>: {nimi}.</span><br/>
                    <span><b>Kunta</b>: {kunta}.</span><br/>
                    <span><b>Maakunta:</b> {maakunta}.</span><br/>
                    <span><b>Ala (ha):</b> ${areaSizeRounded}.</span><br/>
                    <span><b>Greenpeace linkki:</b> <a href="{gp_link}">klikkaa tästä</a>.</span>                   
                </p>                
            `;
        }
    }

    return setPopupContent;
};

export default useSetPopupContent;